import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle} from "reactstrap";
import { setSearchData } from '../../actions/search';

import {withRouter} from 'react-router';
import classnames from 'classnames';
import Files from './files';
import Loader from '../../components/Loader';
import {clientFetchData} from '../../actions/clientData'
import { setSearchScope } from '../../helpers';

class viewAddress extends Component {

    constructor(props) {
        super(props)
        this.state = {address: false}
    }

    componentWillMount() {
    
        if(this.props.clientData.allAddresses) {

            const addressId = this.props.match.params.addressId;
            if(addressId) {
                // -- get client from state
                const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addressId);

                this.setState({
                    address: address
                })
            }
        }


    }

    componentDidMount() {
        window.scrollTo(0, 0)
      }


    componentDidUpdate(prevProps, prevState) {
        if(prevProps.clientData.allAddresses != this.props.clientData.allAddresses) {

            const addressId = this.props.match.params.addressId;
            if(addressId) {
                // -- get client from state
                const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addressId);

                this.setState({
                    address: address
                })
            }
        }
    }

    render() {

        return (
            this.state.address ?

            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <strong>Adres bekijken</strong>
                            </div>
                            <div className="card-block">
                                <form action="" method="post">
                                    <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="klant">Klant</label>
                                        <div className="col-md-9">
                                            <input type="text" id="klant" ref="klant" name="klant" className="form-control" defaultValue={this.state.address ? this.state.address.client_name : ''}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="address_name">Adres naam</label>
                                        <div className="col-md-9">
                                            <input type="text" id="address_name" ref="address_name" name="address_name" className="form-control" defaultValue={this.state.address ? this.state.address.vve_address_name : ''}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="street">Straat</label>
                                        <div className="col-md-9">
                                            <input type="text" id="street" ref="street" name="street" className="form-control" defaultValue={this.state.address ? this.state.address.street : ''}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="postcode">Adres naam</label>
                                        <div className="col-md-9">
                                            <input type="text" id="postcode" ref="postcode" name="postcode" className="form-control" defaultValue={this.state.address ? this.state.address.zipcode : ''}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="city">Stad</label>
                                        <div className="col-md-9">
                                            <input type="text" id="city" ref="city" name="city" className="form-control" defaultValue={this.state.address ? this.state.address.city : ''}/>
                                        </div>
                                    </div>
                                     <div className="form-group row">
                                        <label className="col-md-3 form-control-label" htmlFor="city">Bestand toevoegen</label>
                                        <div className="col-md-9">
                                           <span className={this.state.address.user_id ? this.state.address.user_name ? '' : 'disabled' : 'disabled'}><i className="fa fa-plus"></i> <a href={'/#/files/add/address/'+this.state.address.dp_address_id}>Bestand toevoegen</a></span>
                                        </div>
                                    </div>
                                </form>
                              <Files files={this.state.address.files} dp_address_id={this.state.address.dp_address_id}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : <Loader />
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        clientFetchData: (url) => dispatch(clientFetchData(url + '/api/clients/action/getclients'))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(viewAddress))



// WEBPACK FOOTER //
// ./src/views/Addresses/view.js